import { put, call, fork, takeMaybe } from 'redux-saga/effects'
import { listTagsService } from 'src/api/tag'
import { getTagListSuccess } from 'src/reducers/tag/action'
import { TAG_LIST_GET } from 'src/reducers/tag/type'
import generalSaga from '../general'
import { operationSuccess, operationFail } from 'src/reducers/operation/action'

function* getTagListFlow(payload) {
  try {
    const { callback } = payload
    const response = yield call(listTagsService)
    yield put(getTagListSuccess(response.data))
    yield put(operationSuccess())
    if (callback) callback(response.data)
  } catch (error) {
    yield put(operationFail(error))
  }
}

export default function* getTagListWatcher() {
  while (true) {
    const action = yield takeMaybe(TAG_LIST_GET)
    const { payload } = action

    yield fork(generalSaga, getTagListFlow, payload, false)
  }
}
